import { render, staticRenderFns } from "./SystemList.vue?vue&type=template&id=31b3813c&"
import script from "./SystemList.vue?vue&type=script&lang=ts&"
export * from "./SystemList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports